import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { NecUrl } from './../../model/url/url';
import { Observable } from 'rxjs';
import { Tenant } from './../../model/tenant/tenant';
import { TenantDto } from '../../model/tenant/tenant-dto';
import { TenantNameDto } from './../../model/tenant/tenant-name-dto';


/**
 * tenant æ¥å£è®¿é®
 */
@Injectable()
export class NecTenantInterface {
  constructor(private http: HttpClient) {
  }


  /**
   * è·åå»é¢ä¿¡æ¯
   * @param tenantId å»é¢id
   * @param type  ç±»å admin ç®¡çåæ¥è¯¢ user ç¨æ·æ¥è¯¢
   */
  getTenant(tenantId: number, type: string): Observable<Tenant> {
    if (type === 'admin') {
      return this.http.get<TenantDto>(NecUrl.SERVER_URL + `/server/tenants/${tenantId}?type=admin`)
        .pipe(map(data => {
          return data.tenant;
        }));
    } else {
      return this.http.get<Tenant>(NecUrl.SERVER_URL + `/server/tenants/${tenantId}?type=user`);
    }
  }


  /**
   * å»é¢æç´¢
   */
  getTenantsByName(tenantName: string): Observable<TenantNameDto[]> {
    return this.http.get<TenantNameDto[]>(NecUrl.SERVER_URL + `/server/tenantNames?tenantName=${tenantName}`);
  }
}
